import { Link } from 'react-router-dom'
import { Icon } from '@carrent/ui'

/**
 * Обновления базы знаний.
 *
 * Закреплённые сверху, дальше свежие. Счётчик правок на проверке
 * показывается только тем, кто их проверяет, — для остальных это
 * чужая работа, и цифра была бы шумом.
 */
export function KnowledgeBaseWidget({ data }) {
  const items = data?.items || []
  const pending = data?.pending || 0

  if (!data?.spaces) {
    return (
      <p className="kbw__empty">
        Доступ к базе знаний пока не выдан.
      </p>
    )
  }

  return (
    <div className="kbw">
      {pending > 0 && (
        <Link to="/admin/kb" className="kbw__pending">
          <Icon name="warning" size={15} aria-hidden="true" />
          {pending} {plural(pending, 'правка', 'правки', 'правок')} ждёт проверки
        </Link>
      )}

      {items.length === 0 ? (
        <p className="kbw__empty">Статей пока нет.</p>
      ) : (
        <ul className="kbw__list">
          {items.map((item) => (
            <li key={item.id}>
              <Link to={`/admin/kb`} className="kbw__item">
                {item.pinned && (
                  <Icon name="check" size={13} className="kbw__pin" title="Закреплена" />
                )}
                <span className="kbw__title">{item.title}</span>
                <span className="kbw__date">{relative(item.updated_at)}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

function plural(n, one, few, many) {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few
  return many
}

function relative(iso) {
  if (!iso) return ''
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000)
  if (days <= 0) return 'сегодня'
  if (days === 1) return 'вчера'
  if (days < 7) return `${days} ${plural(days, 'день', 'дня', 'дней')} назад`
  if (days < 30) {
    const w = Math.floor(days / 7)
    return `${w} ${plural(w, 'неделю', 'недели', 'недель')} назад`
  }
  return new Date(iso).toLocaleDateString('ru-RU', { day: '2-digit', month: 'short' })
}
